import { useLocation, useNavigate } from "react-router";
import { toTestId } from "../utils/testId";

const MenuItemCustom = ({ to, primaryText, leftIcon, className, alt = null, isSelected }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const cleanPathname = location.pathname.replace(/^\/+|\/+$/g, "");
  const isOrganizationPath = cleanPathname.startsWith("organization/")
  const isPlatformSettingsPath = cleanPathname.startsWith("platform-settings/")

  return (
    <div onClick={() => navigate(to)} className={className} data-testid={`nav-${toTestId(primaryText)}`}>
      <img src={leftIcon} alt={alt} />
      {(isOrganizationPath || isPlatformSettingsPath) ? (
        <p style={{ color: "var(--layout-sidebar-text)", fontWeight: isSelected ? "500" : "400"}} >
          {primaryText}
        </p>) :
        (<p style={{ color: isSelected ? "var(--layout-sidebar-text)" : "var(--layout-sidebar-text)", fontWeight: isSelected ? "500" : "400", textTransform: "uppercase" }} >
          {primaryText}
        </p>)}
    </div>

  );
};

export default MenuItemCustom;

